<template lang="html">
  <div class="view-pet-profile row page">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 text-left">
          <div class="col-lg-12 pet-profile-height">
            <div class="pet-profile-container">
              <div class="col-md-12 pets-registration-header">
                <div class="row">
                  <div class="col-md-4">
                    <div class="pet-image">
                      <img v-if="pet.petAvatar" class="img-responsive img-circle" v-bind:src="pet.petAvatar">
                      <img v-else class="img-circle img-responsive" src="../../assets/img/icons/empty-image-no-border.svg" alt="Default Pet Image">
                    </div>
                  </div>
                  <div class="col-md-4"></div>
                  <div class="col-md-4 pet-identNumber">
                    <span>{{translation.petProfile.identNumber}}</span>
                    <p id="indeNumber">{{pet.passportId}}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 description-container">
                <div class="row text-left">
                  <div class="col-md-12 text-left">
                    <h3>{{translation.pets.description}}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.name}}</p>
                    <p class="pet-text"><span v-if="pet.petName">{{pet.petName}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.species}}</p>
                    <p class="pet-text"><span v-if="pet.petSpecies">{{pet.petSpecies}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.breed}}</p>
                    <p class="pet-text"><span v-if="pet.petBreed">{{pet.petBreed}}</span></p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.sex}}</p>
                    <p class="pet-text"><span v-if="pet.petSex">{{pet.petSex}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.birthDate}}</p>
                    <p class="pet-text"><span v-if="pet.petBirthDate">{{pet.petBirthDate}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.coat}}</p>
                    <p class="pet-text"><span v-if="pet.petCoat">{{pet.petCoat}}</span></p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pets-identification">
                <div class="row text-left">
                  <div class="col-md-12 text-left">
                    <h3>{{translation.pets.identification}}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.microchip}}</p>
                    <p class="pet-text"><span v-if="pet.microchip">{{pet.microchip}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.dateMicrochipping}}</p>
                    <p class="pet-text"><span v-if="pet.dateMicrochipping">{{pet.dateMicrochipping}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.microchipping}}</p>
                    <p class="pet-text"><span v-if="pet.microchipping">{{pet.microchipping}}</span></p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.tattooNumber}}</p>
                    <p class="pet-text"><span v-if="pet.tattooNumber">{{pet.tattooNumber}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.tattooDate}}</p>
                    <p class="pet-text"><span v-if="pet.tattooDate">{{pet.tattooDate}}</span></p>
                  </div>
                  <div class="col-md-4"></div>
                </div>
              </div>
              <div class="col-md-12 pets-pedigree text-left">
                <div class="row">
                  <div class="col-md-12">
                    <h3>{{translation.pets.pedigree}}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.kennel}}</p>
                    <p class="pet-text"><span v-if="pet.kennel">{{pet.kennel}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.mother}}</p>
                    <p class="pet-text"><span v-if="pet.mother">{{pet.mother}}</span></p>
                  </div>
                  <div class="col-md-4">
                    <p class="pet-header-text">{{translation.pets.father}}</p>
                    <p class="pet-text"><span v-if="pet.father">{{pet.father}}</span></p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 add-pet-button">
                <button class="middle-pet-container">
                  <router-link :to="{name:'update-pet-profile', params:{ petId: response.petId}}">
                    {{translation.profile.edit}}
                  </router-link>
                </button>
                <button class="mobile-pet-button">
                  <router-link :to="{name:'update-pet-profile', params:{ petId: response.petId}}">
                    <img class="img-responsive" src="../../assets/img/icons/edit-mobile.svg"/>
                  </router-link>
                </button>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data(){
    return {
      translation: null,
      pet:[],
      passport: [],
      response: {
        petId: null
      }
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.$bus.$on('approvedPassport', () => {
      this.getPassport();
    });
    this.translation = window.message;
    window.pageHeader = this.translation.pets.profile;
    if (localStorage.getItem('userLoggedIn') != undefined) {
      if ( localStorage.getItem('userLoggedIn') == true
        || localStorage.getItem('userLoggedIn') == 'true') {
          this.response.petId = this.$route.params.petId;
          this.getPet();
      }
    }else {
      this.$router.push('/')
    }

  },
  beforeRouteUpdate ( to, from , next ) {
    this.response.petId = to.params.petId;
    this.getPet();
    localStorage.setItem('petName', this.pet.petName );
    next()
  },
  methods:{
    getPet: function(){
      this.loader = true;
      var formData = this.toFormData(this.response);
      var self = this;
      axios.post('view-pet-profile', formData)
      .then(function (response) {
        self.loader = false;
        if (response.data.result.noAccess) {
          self.$router.push({ name: 'home', params: { lang: window.lang } })
        }else {
          self.pet = response.data.result;
          localStorage.setItem('petName', self.pet.petName );
          self.getPassport();
          if (response.data.result.petReview) {
            self.pet.petReview = '../../..' + response.data.result.petReview;

          }
        }
      })
      .catch(function (error) {
        console.log(error);
      })
    },
    getPassport: function(){
      var formData = this.toFormData(this.response);
      var self = this;
      axios.post('get-pet-passport', formData)
      .then(function(response){
        self.passport = response.data.result;
      })
      .catch(err => err)
    },
    // petLost: function(){
    //   var formData = this.toFormData(this.response);
    //   var self = this;
    //   axios.post('pet-lost', formData)
    //   .then(function(response){
    //     if (response.data.success && response.data.result.serverMessage) {
    //       self.errors.push(response.data.result.serverMessage);
    //     }else {
    //       self.pet;
    //     }
    //   })
    //   .catch(err => err)
    // },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    },
  }
}
</script>

<style lang="css">
.view-pet-profile{
  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
.view-pet-profile .footer {
  color: #707070;
}
.view-pet-profile .pets-registration-header{
  background: #EEEEEE;
  padding: 5em;
  position: relative;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
  margin-bottom: 5em;
}
.pet-profile-height{
  margin-top: 12em;
  margin-bottom: 7em;
}
.pet-profile-container #indeNumber{
  font-size: 1.5em;
  color: #3057B0;
  font-weight: bold;
}
.view-pet-profile .description-container,
.view-pet-profile .pets-identification,
 .view-pet-profile .pets-pedigree {
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
  padding: 1em;
  margin-bottom: 2em;
}
.view-pet-profile .pet-profile-container .pet-image img{
  max-width: 10em;
  display: inline-block;
  border: 4px solid #3057B0;
  position: absolute;
  top: -9em;
  left: 0;
  right: 0;
}
.view-pet-profile .pets-identification,
 .view-pet-profile .pets-pedigree {
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
}
.pet-profile-container .pet-profile-header{
  background: #EEEEEE;
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
}
.pet-profile-container h3{
  border-bottom: 1px solid #707070;
  padding: 1em;
  color: #3057B0;
}
.pet-profile-container .pet-header-text{
  color: #707070;
  margin-top: 2em;
}
.pet-profile-container .pet-text{
  color: #000;
  font-size: 1.1em;
  font-weight: 600;

}
.pet-profile-container .pet-image img {
  width: 10em;
  height: 10em;
  display: inline-block;
  border: 2px solid #3057B0;
}
.pet-profile-container .pet-adress .pet-header-text,
.pet-profile-container .pet-adress .pet-text{
  margin-left: 1em;
}
.pet-profile-container .pet-adress .pet-text{
  padding-bottom: 2em;
}
.pet-profile-container{
  position: relative;
}
.add-pet-button{
  position: fixed;
  bottom: 50px;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.add-pet-button .middle-pet-container a{
  display: inline-block;
  background: #FE7154;
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 2em;
  color: #fff;
}
.add-pet-button .middle-pet-container,
.add-pet-button .mobile-pet-button {
  background: none;
  border: none;
}
.add-pet-button .mobile-pet-button{
  display: none;
}

@media (max-width: 1024px) {
  .add-pet-button .middle-pet-container{
    display: none;
  }
  .add-pet-button .mobile-pet-button{
    position: fixed;
    display: block;
    bottom: 9em;
    right: 0;
    z-index: 1;
  }
  .view-pet-profile .pet-profile-container .pet-image img{
    position: relative;
    margin-bottom: 1em;
  }
  .view-pet-profile{
    margin-bottom: 13em;
  }

}
@media (max-width: 768px) {
  .add-pet-button .mobile-pet-button{
    bottom: 7em;
  }
  .view-pet-profile .pet-profile-container .pet-image img{
    max-width: 10em;
    max-height: 10em;
      top: 0;
    }
    .view-pet-profile .pets-registration-header{
      padding: 0;
    }
    .pet-profile-height {
        margin-top: 5em;
        margin-bottom: 13em;
    }
    .view-pet-profile .pet-profile-container .pet-image,
    .view-pet-profile .pet-profile-container .pet-identNumber{
      text-align: center;
    }

}
</style>
